var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"alert-demo"}},[_c('alert-default'),_c('alert-title'),_c('alert-color'),_c('alert-closable'),_c('alert-icon'),_c('alert-example')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }